import React from 'react';
import {TouchableOpacity, StyleSheet} from 'react-native';
import {CustomText} from '../../../../components';
import {useTranslation} from 'react-i18next';
import {CustomCheckbox} from '../../../../components/checkbox/Checkbox';
import { useDispatch } from 'react-redux';
import { getUser } from '../../../../actions/user';
import { View } from 'react-native';

const NotShowAgain = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch()

  return (
    <View style={styles.container}>
      <CustomText size={13} font={'400'} color={'#2D2D2D'}>
        {t('do_not_show_this_message')}
      </CustomText>
      <CustomCheckbox
        onPress={checked => {
          dispatch(getUser({notshow: checked}));
        }}
      />
    </View>
  );
};

export default NotShowAgain;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    borderColor: '#DCDCDC',
    borderWidth: 1,
    paddingHorizontal: 12,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderRadius: 25,
    height: 44,
    marginBottom: 10,
  },
});
